import { render } from "./WatchOnTv.vue?vue&type=template&id=18ab76da&scoped=true"
import script from "./WatchOnTv.vue?vue&type=script&lang=js"
export * from "./WatchOnTv.vue?vue&type=script&lang=js"

import "./WatchOnTv.vue?vue&type=style&index=0&id=18ab76da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ab76da"]])

export default __exports__